import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Check, MessageCircle } from 'lucide-react';
export function Packages() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-sand-light" data-id="element-118">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
        <div className="text-center mb-12" data-id="element-120">
          <h2 className="text-4xl font-heading font-bold text-ocean-dark mb-4" data-id="element-121">
            {t.packages.title}
          </h2>
          <div className="w-24 h-1 bg-turquoise mx-auto rounded-full" data-id="element-122" />
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 22
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-ocean-dark rounded-3xl p-8 sm:p-10 shadow-xl border-t-4 border-turquoise text-white" data-id="element-123">
          <img src="https://cdn.magicpatterns.com/uploads/aifgHKgDB7GaFaemiHaRod/LOGO_PNG_ORIGI.png" alt="Blu Ocean Tours" className="h-20 w-auto object-contain mb-8 drop-shadow-[0_4px_20px_rgba(0,180,216,0.3)]" data-id="element-124" />
          <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-4 mb-9" data-id="element-125">
            {t.packages.boat.features.map(feature => <li key={feature} className="flex items-start gap-3 text-gray-200" data-id="element-126">
                <Check className="w-5 h-5 text-turquoise flex-shrink-0 mt-0.5" data-id="element-127" />
                <span data-id="element-128">{feature}</span>
              </li>)}
          </ul>
          <a href="https://wa.link/qca29f" target="_blank" rel="noreferrer" className="inline-flex w-full items-center justify-center gap-2 bg-turquoise hover:bg-turquoise-light text-ocean-dark font-bold py-3.5 px-6 rounded-full transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white" data-id="element-129">
            <MessageCircle size={20} data-id="element-130" />
            {t.packages.boat.cta}
          </a>
        </motion.div>
      </div>
    </section>;
}